import { useMatches } from "@tanstack/react-router";
import { useLayoutEffect } from "react";
import z from "zod";

type Props = {
  children: React.ReactNode;
};

const withTitleSchema = z.object({
  meta: z.object({
    title: z.string().optional(),
    isTitleRoot: z.boolean().optional(),
  }),
});

// https://github.com/TanStack/router/discussions/1056#discussioncomment-10275259
export function Meta({ children }: Props) {
  const matches = useMatches();
  const meta = matches.at(-1)?.staticData.meta;

  useLayoutEffect(() => {
    let titleParts: string[] = [];

    for (const match of matches) {
      const { data: staticData } = withTitleSchema.safeParse(match.staticData);
      const { data: loaderData } = withTitleSchema.safeParse(match.loaderData);

      if (staticData?.meta.isTitleRoot) {
        titleParts = [];
      }

      const title = loaderData?.meta.title ?? staticData?.meta.title;

      if (title) {
        titleParts.push(title);
      }
    }

    titleParts.unshift("Lasso Sales");

    document.title = [...titleParts].reverse().join(" - ");
  }, [matches, meta]);

  return children;
}
